module.exports = __webpack_public_path__ + "static/media/mobile-step3-ar.61ec1a7d.png";